<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}<button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
      </button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div v-if="generalErrorMessage" class="row">
          <div class="col">
            <div class="alert alert-danger" role="alert">
              {{ generalErrorMessage }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-8">
            <b-form-group :label-cols="5"
                          label="Description"
                          :state="stateForField('description')"
                          :invalid-feedback="errorForField('description')"
                          label-class="text-right"
                          class="mt-2">
              <b-form-input v-model="estimateAscFee.description"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="5"
                          label="Short Code"
                          :state="stateForField('shortCode')"
                          :invalid-feedback="errorForField('shortCode')"
                          label-class="text-right"
                          class="mt-2">
              <b-form-input v-model="estimateAscFee.shortCode"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="5" label="Fee Type" :state="stateForField('feeType')" :invalid-feedback="errorForField('feeType')" label-class="text-right">
              <b-select class="input-border" v-model="estimateAscFee.feeType" :options="feeTypeOptions">
              </b-select>
            </b-form-group>
            <span v-if="estimateAscFee && estimateAscFee.feeType === 'FlatAmount'">
            <b-form-group :label-cols="5" label="Amount" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group prepend="$">
                <b-form-input id="amountField" v-model="estimateAscFee.amount"></b-form-input>
              </b-input-group>
            </b-form-group>
              </span>
            <span v-else>
              <b-form-group :label-cols="5" label="Percent" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group append="%">
                <b-form-input id="amountField" v-model="estimateAscFee.amount"></b-form-input>
              </b-input-group>
            </b-form-group>
            </span>
            <b-form-group :label-cols="5" label="Covered Item" :state="stateForField('coveredItem')" :invalid-feedback="errorForField('coveredItem')" label-class="text-right">
              <b-form-radio-group class="input-border pt-2" v-model="estimateAscFee.coveredItem" :options="yesNoOptions"></b-form-radio-group>
            </b-form-group>
            <b-form-group :label-cols="5" label="Default" :state="stateForField('default')" :invalid-feedback="errorForField('default')" label-class="text-right">
              <b-form-radio-group class="input-border pt-2" v-model="estimateAscFee.appliedByDefault" :options="yesNoOptions"></b-form-radio-group>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="saveEstimateAscFee()">Save</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>
<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import _ from 'lodash'
  import api from '@/services/api'

  export default {
    name: 'EstimateAscFeeModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      editEstimateAscFee: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        estimateAscFee: {},
        feeTypeOptions: [
          { value: null, text: 'Click to Select', disabled: true },
          { value: 'FlatAmount', text: 'Flat Amount' },
          { value: 'PercentageOfCodes', text: 'Percentage Of Codes' },
          { value: 'PercentageOfTotal', text: 'Percentage Of Total' }
        ],
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ]
      }
    },
    computed: {
      title () {
        if (this.estimateAscFee && this.estimateAscFee.organizationEstimateAscFeeId) {
          return 'Edit Estimate Facility Fee'
        }
        return 'Create Estimate Facility Fee'
      }
    },
    watch: {
      editEstimateAscFee (newValue) {
        this.estimateAscFee = _.clone(newValue)
        if (this.estimateAscFee.feeType === 'PercentageOfCodes') {
          this.estimateAscFee.amount = this.estimateAscFee.amount * 100
        }
        if (this.estimateAscFee.feeType === 'PercentageOfTotal') {
          this.estimateAscFee.amount = this.estimateAscFee.amount * 100
        }
      }
    },
    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.estimateAscFee.description) {
          this.addErrorForField('description', 'You must choose a description')
        }

        if (!this.estimateAscFee.feeType) {
          this.addErrorForField('feeType', 'You must choose a fee type')
        }

        if (!this.estimateAscFee.amount) {
          this.addErrorForField('amount', 'You must enter a number')
        }

        return !this.hasErrors()
      },
      closeModal () {
        this.$emit('update:visible', false)
      },
      saveEstimateAscFee () {
        if (this.isSaving) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.clearAllErrors()
        const ascFee = _.assign({}, this.estimateAscFee)
        if (ascFee.feeType === 'PercentageOfCodes' || ascFee.feeType === 'PercentageOfTotal') {
          if (ascFee.amount > 1) {
            ascFee.amount = ascFee.amount / 100
          }
        }
        this.isSaving = true
        api.post('Dashboard/EstimateAscFee', ascFee).then(response => {
          this.isSaving = false
          this.$emit('updated', response)
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    }
  }
</script>
